import {ValueDefinition} from '@/model/types';

export const enum Province {
  ALBERTA = 'DV-46#0',
  BRISTISH_COLUMBIA = 'DV-46#1',
  PRINCE_EDWARD_ISLAND = 'DV-46#2',
  MANITOBA = 'DV-46#3',
  NEW_BRUNSWICK = 'DV-46#4',
  NOVA_SCOTIA = 'DV-46#5',
  NUNAVUT = 'DV-46#6',
  ONTARIO = 'DV-46#7',
  QUEBEC = 'DV-46#8',
  SASKATCHEWAN = 'DV-46#9',
  NEWFOUNDLAND_LABRADOR = 'DV-46#10',
  NORTHWEST_TERRITORIES = 'DV-46#11',
  YUKON = 'DV-46#12',
}

export const DV_46 = {
  id: 'DV-46',
  description: {
    fr: 'Province',
    en: 'Province',
  },
  type: 'code',
  values: [
    {
      id: '0',
      value: {
        fr: 'Alberta',
        en: 'Alberta',
      },
      properties: {
        code: 'AB',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Colombie-Britannique',
        en: 'British Columbia',
      },
      properties: {
        code: 'BC',
      },
    },
    {
      id: '2',
      value: {
        fr: 'Île du Prince Édouard',
        en: 'Prince Edward Island',
      },
      properties: {
        code: 'PE',
      },
    },
    {
      id: '3',
      value: {
        fr: 'Manitoba',
        en: 'Manitoba',
      },
      properties: {
        code: 'MB',
      },
    },
    {
      id: '4',
      value: {
        fr: 'Nouveau-Brunswick',
        en: 'New Brunswick',
      },
      properties: {
        code: 'NB',
      },
    },
    {
      id: '5',
      value: {
        fr: 'Nouvelle-Écosse',
        en: 'Nova Scotia',
      },
      properties: {
        code: 'NS',
      },
    },
    {
      id: '6',
      value: {
        fr: 'Nunavut',
        en: 'Nunavut',
      },
      properties: {
        code: 'NU',
      },
    },
    {
      id: '7',
      value: {
        fr: 'Ontario',
        en: 'Ontario',
      },
      properties: {
        code: 'ON',
      },
    },
    {
      id: '8',
      value: {
        fr: 'Québec',
        en: 'Quebec',
      },
      properties: {
        code: 'QC',
      },
    },
    {
      id: '9',
      value: {
        fr: 'Saskatchewan',
        en: 'Saskatchewan',
      },
      properties: {
        code: 'SK',
      },
    },
    {
      id: '10',
      value: {
        fr: 'Terre-Neuve et Labrador',
        en: 'Newfoundland and Labrador',
      },
      properties: {
        code: 'NL',
      },
    },
    {
      id: '11',
      value: {
        fr: 'Territoires du Nord-Ouest',
        en: 'Northwest territories',
      },
      properties: {
        code: 'NT',
      },
    },
    {
      id: '12',
      value: {
        fr: 'Yukon',
        en: 'Yukon',
      },
      properties: {
        code: 'YT',
      },
    },
  ],
} as const satisfies ValueDefinition;
